import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const API = process.env.REACT_APP_BACKEND_URL;

export default function PageTracker() {
  const location = useLocation();

  useEffect(() => {
    const track = async () => {
      try {
        await fetch(`${API}/api/track/visit`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            page: location.pathname,
            referrer: document.referrer
          })
        });
      } catch {
        // Silent fail — tracking should never break the app
      }
    };
    track();
  }, [location.pathname]);

  return null;
}
